import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

import { UIFormPanel } from '@futrli/ui-components';

import { SelectOrganisationsPanel } from './select-organisations-panel/select-organisations-panel';
import styles from './settings.scss';
import { SettingsForm } from './settings-form/settings-form';

export interface SettingsProps {
  editing?: boolean;
}

export const Settings = ({ editing }: SettingsProps) => {
  const intl = useIntl();
  return (
    <div className={clsx(styles.grid, { [styles.editing]: editing })}>
      <div>
        <UIFormPanel
          title={intl.formatMessage({
            id: 'consolidation.consolidation_settings',
            defaultMessage: 'Consolidation settings'
          })}
        >
          <SettingsForm />
        </UIFormPanel>
      </div>

      <div className={styles.orgsPanel}>
        <SelectOrganisationsPanel />
      </div>
    </div>
  );
};
